import React from 'react';
import './LabeledValue.css';

const LabeledValue = ({ label, children }) => (
    <div>
        <dt>{label}</dt>
        <dd>{children}</dd>
    </div>
);

export default LabeledValue;
